const BASE_URL = "http://johnrmarshallsr-001-site2.ctempurl.com/api/"
// const BASE_URL = "http://localhost:5111/api/"
// const BASE_URL = "http://192.168.32.193:801/api/"
// const BASE_URL = "https://localhost:44383/api/"

export default {
    BASE_URL: BASE_URL
}

